import useUrlQueryParams from '../../services/useUrlQueryParams';
import SearchParams from '../../constants/SearchParams';

/**
 * A hook that takes errorType from URL search params and returns its corresponding message keys
 * @return {[string, string]}
 */
export default function useErrorPageTitleAndDescriptionMessageKeys() {
    const searchParams = useUrlQueryParams();
    const errorType = searchParams.get(SearchParams.ERROR_TYPE)?.toLowerCase() ?? 'generic_error';
    const titleKey = `error_page.${errorType}_title`;
    const descriptionKey = `error_page.${errorType}_description`;

    return [titleKey, descriptionKey];
}
